import { RAQIV2ChartResourceType as ChartResourceType } from '@modules/clients/analytics';

export default ChartResourceType;
